import { IField, spError } from '@eventr/common'
import { StateCreator } from 'zustand'
import { DataAPI } from '../data/Data'
import { BoundStore } from './bound.store'
interface FieldState {
    fields: IField[]
}

interface FieldActions {
    getFieldsForSection: (sectionID: number) => IField[]
    getFieldById: (id: number) => IField | undefined
    fetchFields: () => Promise<void>
}
export interface IFieldSlice extends FieldState, FieldActions {}
export const createFieldSlice: StateCreator<
    BoundStore,
    [['zustand/devtools', never]],
    [],
    IFieldSlice
> = (set, get) => ({
    fields: [],

    getFieldsForSection: (sectionID: number) => {
        return get().fields.filter(
            (f) => f.section.toString() === sectionID.toString()
        )
    },
    getFieldById: (id: number) => {
        return get().fields.find((f) => f.id.toString() === id.toString())
    },
    fetchFields: async () => {
        try {
            const fields = await DataAPI.getFields()
            set({ fields }, false, 'fetchFields')
        } catch (e: any) {
            if (e?.code === 'ERR_CANCELED') return
            spError('Failed to fetch fields')
        }
    },
})
